import { createAction } from '@reduxjs/toolkit';

export const setUserData = createAction('@setUserData', (item) => {
  return { payload: item };
});
export const clearReduxState = createAction('@clearReduxState');
